var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ui-dialog",
    {
      ref: "dialog",
      staticClass: "web-player-dialog",
      attrs: { closable: "", large: "" },
      on: { open: _vm.play },
    },
    [
      _c("template", { slot: "header" }, [
        _c("h6", { staticClass: "ui-title" }, [
          _vm._v(_vm._s(_vm.mediaData.comment || _vm.mediaData.title)),
          _c("div", { staticClass: "ui-caption" }, [
            _vm._v(_vm._s(_vm._f("date")(_vm.mediaData.created))),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("WebPlayer", { ref: "webPlayer" }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }